<template>
	<NoLineBreaks v-if="geoFencingRef == null">{{ $t('geoFencing.withoutRestrictions') }}</NoLineBreaks>
	<div v-else>
		<NoLineBreaks>{{ $t('geoFencing.latitude') }} {{ geoFencingDisplay.bCoord }}</NoLineBreaks>
		<NoLineBreaks>{{ $t('geoFencing.longitude') }} {{ geoFencingDisplay.lCoord }}</NoLineBreaks>
		<NoLineBreaks>{{ $t('geoFencing.radius') }} {{ geoFencingDisplay.radius }} {{ $t('geoFencing.radiusKm') }}</NoLineBreaks>
	</div>
</template>

<script>
import { computed, toRef } from 'vue';

import Utils from '@/api/Utils';

import NoLineBreaks from '@/components/common/NoLineBreaks';

export default {
	components: {
		NoLineBreaks,
	},
	props: ['geoFencing'],
	setup(props) {
		const geoFencingRef = toRef(props, 'geoFencing');
		const geoFencingDisplay = computed(() => {
			if (geoFencingRef.value == null) {
				return {};
			}
			return {
				bCoord: Utils.formatLatLong(geoFencingRef.value['b_coord']),
				lCoord: Utils.formatLatLong(geoFencingRef.value['l_coord']),
				radius: Utils.formatLatLong(geoFencingRef.value['radius']),
			}
		});
		return {
			geoFencingRef,
			geoFencingDisplay,
		};
	},
}
</script>